import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import CheckboxWithTitle from '@/ui/CheckboxWithTitle/CheckboxWithTitle';

const ConditionCheck = ({ onChange, checked }) => {
  const { t } = useTranslation();
  return (
    <CheckboxWithTitle
      reverse
      onChange={onChange}
      checked={checked}
      itemScope
      itemType='https://schema.org/CheckAction'
    >
      {t('esim:common.termsAndConditions')}
    </CheckboxWithTitle>
  );
};

export default ConditionCheck;
